import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
@Directive({
  selector: '[isPhoneCC]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidPhoneCCDirective, multi: true }]
})
export class ValidPhoneCCDirective {

  constructor() { }

  public validate(control: AbstractControl): { [key: string]: any } {
    let phoneNumber = /^([0-9]+)$/;
    if (control.value === null || control.value === undefined) {
      return null;
    }
    else {
      if (control.value.trim() == '') {
        return null;
      }
      else {
        let phoneList = control.value.trim().split(';');
        let isAllValid = true;
        phoneList.forEach(element => {
          if (element != "") {
            let valid = phoneNumber.test(element.trim());
            if (element.trim().length != 10) {
              isAllValid = false;
            }
            if (!valid) {
              isAllValid = false;
            }
          }
        });
        if (isAllValid) {
          return null;
        }
        else {

          return { 'isPhone': true };
        }

      }
    }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/valid-phonecc.directive.ts